module.exports = __webpack_public_path__ + "img/addSort.52531aea.svg";